<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    {{ 'transfer.scanQr' | translate }}
  </h5>
  <button type="button" class="btn-close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  @if (insecureContext) {
    <div class="text-warning small d-flex align-items-center gap-1 mb-0">
      <i class="fa fa-lock"></i>{{ 'transfer.insecureContext' | translate }}
    </div>
  } @else if (noCameraFound) {
    <div class="text-warning small d-flex align-items-center gap-1 mb-0">
      <i class="fa fa-video-camera"></i>{{ 'transfer.noCameraFound' | translate }}
    </div>
  } @else if (cameraPermissionDenied) {
    <div class="d-flex flex-column gap-2">
      <div class="text-danger small d-flex align-items-center gap-1 mb-0">
        <i class="fa fa-exclamation-triangle"></i
        >{{ 'transfer.cameraPermissionDenied' | translate }}
      </div>
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary align-self-start"
        (click)="retryCameraAccess()">
        {{ 'transfer.retryCamera' | translate }}
      </button>
    </div>
  } @else {
    @if (availableCameras.length > 1) {
      <select
        class="form-select form-select-sm mb-2"
        [ngModel]="selectedCamera"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onCameraDeviceChange($event)">
        @for (device of availableCameras; track device.deviceId) {
          <option [ngValue]="device">{{ getCameraLabel(device) }}</option>
        }
      </select>
    }
    <div class="zg-qr-scanner-modal mx-auto position-relative" #scannerHost>
      <zxing-scanner
        [formats]="BARCODE_FORMATS"
        [videoConstraints]="videoConstraints"
        [device]="selectedCamera"
        (scanComplete)="onScanComplete($event)"
        (camerasFound)="onCamerasFound($event)"></zxing-scanner>
      <canvas class="zg-qr-overlay-canvas" #overlayCanvas></canvas>
      @if (!isDetected) {
        <div class="zg-qr-scanline"></div>
      }
    </div>
  }
</div>
